import { AxiosResponse } from 'axios';
import {
  call,
  CallEffect,
  ForkEffect,
  put,
  PutEffect,
  takeLatest,
} from 'redux-saga/effects';
import { $alerts } from '@pickit/pickit-components';
import i18next from '../../config/i18next';
import { actions } from '../../redux/resetPassword/actions';
import * as ResetPasswordService from '../../services/resetPassword/resetPassword';
import { ResetPasswordResponseType } from '../../services/resetPassword/types';

export function* resetPassword(
  action: any,
): Generator<
  | CallEffect<AxiosResponse<ResetPasswordResponseType>>
  | PutEffect<{ type: string }>
  | CallEffect<void>,
  void,
  ResetPasswordResponseType
> {
  const response = yield call(
    ResetPasswordService.resetPassword,
    action.payload,
  );
  switch (response.status) {
    case 500:
      yield put(actions.getResetPasswordError(false));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
    case 400:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
    case 401:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 403:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 404:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 429:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t(`LoginService:errorCode${response.data.code}`),
        subMessage: i18next.t(
          `LoginService:errorCode${response.data.code}Body`,
        ),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });

    case 200:
      yield put(actions.getResetPasswordSuccess(response.data));
      action.payload.onSuccess(response.data);
      return $alerts.next({
        type: 'success',
        title: i18next.t('LoginService:successPasswordSentTitle'),
        subMessage: i18next.t('LoginService:successPasswordSentBody'),
        onConfirmLabel: i18next.t(`LoginService:successModalButton`),
      });

    case 201:
      yield put(actions.getResetPasswordSuccess(response.data));
      action.payload.onSuccess(response.data);
      return $alerts.next({
        type: 'success',
        title: i18next.t('LoginService:successPasswordSentTitle'),
        subMessage: i18next.t('LoginService:successPasswordSentBody'),
        onConfirmLabel: i18next.t(`LoginService:successModalButton`),
      });
    default:
      yield put(actions.getResetPasswordError(true));
      return $alerts.next({
        type: 'error',
        title: i18next.t('LoginService:errorGeneralTitle'),
        subMessage: i18next.t('LoginService:errorGeneralBody'),
        onConfirmLabel: i18next.t(`LoginService:errorModalButton`),
      });
  }
}
const sagas: ForkEffect<never>[] = [
  takeLatest(actions.getResetPasswordRequest.type, resetPassword),
];

export default sagas;
